export type CanvasTextSender = (text: string) => boolean;

let sender: CanvasTextSender | null = null;

export const registerCanvasTextSender = (
  fn: CanvasTextSender,
): (() => void) => {
  sender = fn;
  return () => {
    if (sender === fn) sender = null;
  };
};

export const canvasTextSenderReady = (): boolean => sender !== null;

export const deliverCanvasText = (text: string): boolean =>
  sender ? sender(text) : false;
